import { render, staticRenderFns } from "./TokenSuccessView.vue?vue&type=template&id=5361575e&"
import script from "./TokenSuccessView.vue?vue&type=script&lang=ts&"
export * from "./TokenSuccessView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports